import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingSection() {
  const benefits = ['Ebook completo (5 módulos)', 'Bonus: Plantillas para cotizar', 'Bonus: Guía de objeciones', 'Acceso inmediato y de por vida', 'Actualizaciones futuras incluidas'];
  return <section id="oferta" className="bg-navy text-cream py-32 px-5 relative" data-id="element-111">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-112"></div>

      <div className="max-w-lg mx-auto relative z-10" data-id="element-113">
        <div className="text-center mb-10" data-id="element-114">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-4" data-id="element-115">
            Todo incluido.{' '}
            <span className="text-gold italic" data-id="element-116">Un solo pago.</span>
          </h2>
          <p className="font-dmsans text-cream/60" data-id="element-117">
            Sin suscripciones. Tuyo para siempre.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy rounded-xl border border-gold/30 overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-118">
          <div className="p-10 text-center border-b border-gold/10" data-id="element-119">
            <div className="mb-2" data-id="element-120">
              <span className="font-playfair text-6xl md:text-7xl font-bold text-gold" data-id="element-121">
                $19.990
              </span>
            </div>
            <p className="font-dmsans text-sm text-cream/50 uppercase tracking-widest" data-id="element-122">
              Pesos Argentinos
            </p>
          </div>

          <div className="p-10" data-id="element-123">
            <ul className="space-y-5 mb-10" data-id="element-124">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-125">
                  <Check className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-126" />
                  <span className="font-dmsans text-cream/90" data-id="element-127">{benefit}</span>
                </li>)}
            </ul>

            <a href="https://1marvt-uy.myshopify.com/checkouts/cn/hWNA9wnUkaCuu217d67e9GxW/es-ar?_r=AQABvb9kJNeai9b90xDQXdccT9ieTUuslKeR07HVYPreqzk&preview_theme_id=184270029099" target="_blank" rel="noopener noreferrer" className="block w-full bg-gold text-navy font-dmsans font-bold text-lg py-5 px-8 rounded hover:bg-cream hover:scale-[1.02] transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] text-center" data-id="element-128">
              Descargá el E-book ahora
            </a>
            <p className="font-dmsans text-xs text-cream/40 mt-4 text-center" data-id="element-129">
              Pago 100% seguro. Entrega inmediata.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}